import React, { useState, useEffect } from 'react';
import { useOrganizationTimezone } from '../../hooks/useOrganizationTimezone';
import './Clock.css';

const Clock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const { timezone } = useOrganizationTimezone();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = () => {
    return currentTime.toLocaleTimeString('es-ES', {
      timeZone: timezone,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const formatDate = () => {
    return currentTime.toLocaleDateString('es-ES', {
      timeZone: timezone,
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  };

  return (
    <div className="clock-widget">
      <i className="fas fa-clock"></i>
      <div className="clock-text">
        <span className="time-display">{formatTime()}</span>
        <span className="date-display">{formatDate()}</span>
      </div>
    </div>
  );
};

export default Clock;
